import { deepAnalysisApi } from '../service';
import {
    SitemapImportProcess,
    AddSitemapImportProcessParams,
    FetchActiveSitemapImportProcessesParams,
    GenericProcess,
    AddUrlAnalysisProcessParams,
    FetchActiveProcessesParams,
    AddGenericAnalysisProcessResponse,
    AddGenericAnalysisProcessParams,
} from './types';

const processApi = deepAnalysisApi.injectEndpoints({
    endpoints: (builder) => ({
        fetchActiveSitemapImportProcesses: builder.query<SitemapImportProcess[], FetchActiveSitemapImportProcessesParams>({
            query: (args) => {
                const { w_guid } = args;

                return {
                    method: 'GET',
                    url: `/import-sitemap?w_guid=${w_guid}`,
                };
            },

            providesTags: (result, error, args) => [{ type: 'ActiveProcesses', id: `${args.w_guid}_sitemap_import` }],
        }),

        addSitemapImportProcess: builder.mutation<SitemapImportProcess, AddSitemapImportProcessParams>({
            query: (args) => {
                return {
                    method: 'POST',
                    body: args,
                    url: '/import-sitemap',
                };
            },

            invalidatesTags: (result, error, args) => [{ type: 'ActiveProcesses', id: `${args.w_guid}_sitemap_import` }],
        }),

        fetchActiveProcesses: builder.query<GenericProcess[], FetchActiveProcessesParams>({
            query: (args) => {
                const { process_type, w_guid } = args;

                return {
                    method: 'GET',
                    url: `/on-page-seo/active?process_type=${process_type}&w_guid=${w_guid}`,
                };
            },

            providesTags: (result, error, args) => [{ type: 'ActiveProcesses', id: `${args.w_guid}_${args.process_type}` }],
        }),

        addUrlAnalysisProcess: builder.mutation<AddGenericAnalysisProcessResponse, AddUrlAnalysisProcessParams>({
            query: (args) => {
                return {
                    method: 'POST',
                    body: args,
                    url: '/on-page-seo/url',
                };
            },
        }),

        addUrlAnalysisProcessBatch: builder.mutation<AddGenericAnalysisProcessResponse, AddGenericAnalysisProcessParams>({
            query: (args) => {
                return {
                    method: 'POST',
                    body: args,
                    url: '/on-page-seo/batch',
                };
            },

            invalidatesTags: (result, error, args) => [{ type: 'ActiveProcesses', id: `${args.w_guid}_on_page_seo_batch_url_analysis` }],
        }),

        addDomainAnalysisProcess: builder.mutation<AddGenericAnalysisProcessResponse, AddGenericAnalysisProcessParams>({
            query: (args) => {
                return {
                    method: 'POST',
                    body: args,
                    url: '/on-page-seo/domain',
                };
            },

            invalidatesTags: (result, error, args) => [{ type: 'ActiveProcesses', id: `${args.w_guid}_on_page_seo_domain_analysis` }],
        }),
    }),
});

export const {
    useAddDomainAnalysisProcessMutation,
    useAddSitemapImportProcessMutation,
    useAddUrlAnalysisProcessBatchMutation,
    useAddUrlAnalysisProcessMutation,
    useFetchActiveProcessesQuery,
    useFetchActiveSitemapImportProcessesQuery,
} = processApi;
